import { isEmptyDeep } from './utility';
import Api from '@/services/Api.js';

export const setHttpToken = (token) => {
	if(isEmptyDeep(token)) {
		Api.defaults.headers.common['Authorization'] = null;
		return;
	}
	Api.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}